








import { reportIndexPvUvAndTimeCost, language } from '@tencent/ppd-base-libs';
import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { wxBridge } from '@tencent/wphk-base-wx';
import { i18n } from './i18n';
import { useGlobalData } from './hooks/use-global-data';
import { useConfigStore } from './store/config';
import { useLogin } from './store/login';
import ContentLoader from '@/components/common/content-loader.vue';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import { cfgInit } from '@/business/act-config';

export default defineComponent({
  components: { ContentLoader, BaseComponent },
  setup() {
    const configStore = useConfigStore();
    const globalData = useGlobalData();
    const loginStore = useLogin();

    // 语言
    const lang = ref('');
    lang.value = language.getLanguage();

    const isShow = ref(false);

    onMounted(async () => {
      try {
        reportIndexPvUvAndTimeCost();
        await cfgInit();
        /** 设置微信分享文案 */
        wxBridge.setShareInfo({
          title: i18n('日行一善，每日做好事'),
          desc: i18n('捐贈公益印花，WeChat Pay HK將代你捐贈善款，幫助有需要人士'),
          link: 'https://prom.wechatpay.com.hk/good-deed-day/index.shtml?ADTAG=fromShareInfo',
          imgUrl: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20230511094228/icon-good-deed-day-share.png',
        });

        // 初始化高授权
        loginStore.init();

        // 初始化配置
        await configStore.getConfig();

        // 初始化数据
        await globalData.refreshData();
        isShow.value = true;
      } catch (error) {
        console.log(error);
      }
    });
    return {
      lang,
      isShow,
    };
  },
});
